import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["progress", "bg", "barSize", "children"];
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { width } from 'styled-system';
import { get } from '../constants.js';
import sx from '../sx.js';
import { warning } from '../utils/warning.js';
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Item = styled.span.withConfig({
  displayName: "ProgressBar__Item",
  componentId: "sc-1jz8j7n-0"
})(["width:", ";background-color:", ";", ";"], function (props) {
  return props.progress ? "".concat(props.progress, "%") : 0;
}, get('colors.success.emphasis'), sx);
Item.displayName = 'ProgressBar.Item';
var sizeMap = {
  small: '5px',
  large: '10px',
  default: '8px'
};
var ProgressContainer = styled.span.withConfig({
  displayName: "ProgressBar__ProgressContainer",
  componentId: "sc-1jz8j7n-1"
})(["display:", ";overflow:hidden;background-color:", ";border-radius:", ";height:", ";", " ", ";"], function (props) {
  return props.inline ? 'inline-flex' : 'flex';
}, get('colors.border.default'), get('radii.1'), function (props) {
  return sizeMap[props.barSize || 'default'];
}, width, sx);
var ProgressBar = /*#__PURE__*/forwardRef(function (_ref, forwardRef) {
  var progress = _ref.progress,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'success.emphasis' : _ref$bg,
    _ref$barSize = _ref.barSize,
    barSize = _ref$barSize === void 0 ? 'default' : _ref$barSize,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (children && progress) {
    throw new Error('You should pass `progress` or children, not both.');
  }
  process.env.NODE_ENV !== "production" ? warning(children && typeof rest['aria-valuenow'] === 'undefined' && typeof rest['aria-valuetext'] === 'undefined', 'Expected `aria-valuenow` or `aria-valuetext` to be provided to <ProgressBar>. Provide one of these values so screen reader users can determine the current progress. This warning will become an error in the next major release.') : void 0;
  var progressAsNumber = typeof progress === 'string' ? parseInt(progress, 10) : progress;
  var ariaAttributes = {
    'aria-valuenow': progressAsNumber ? Math.round(progressAsNumber) : undefined,
    'aria-valuemin': 0,
    'aria-valuemax': 100,
    'aria-busy': progressAsNumber ? progressAsNumber !== 100 : false
  };
  return /*#__PURE__*/React__default.createElement(ProgressContainer, _extends({
    ref: forwardRef,
    role: "progressbar",
    barSize: barSize
  }, ariaAttributes, rest), children !== null && children !== void 0 ? children : /*#__PURE__*/React__default.createElement(Item, {
    progress: progress,
    sx: {
      backgroundColor: bg
    }
  }));
});
ProgressBar.displayName = 'ProgressBar';
export { Item, ProgressBar };